import { NgModule } from '@angular/core';
import { NcMouseTooltipService } from './mouse-tooltip.service';

@NgModule({
    providers: [NcMouseTooltipService]
})
export class NcMouseTooltipServiceModule { }